<template>
  <main class="exam-success">
    <section class="exam-success__content">
      <div class="exam-success__icon-wrapper">
        <div class="exam-success__circle">
          <FileTextSvg />
        </div>
        <div class="exam-success__check">
          <CheckGreenCircle />
        </div>
      </div>

      <p class="exam-success__message" v-if="showLabel">Identifiquei os exames com sucesso!</p>
    </section>
  </main>
</template>

<script>
import FileTextSvg from '@/assets/img/icons/file-text-component.svg?inline';
import CheckGreenCircle from '@/assets/img/icons/check-green-circle.svg?inline';

export default {
  components: {
    FileTextSvg,
    CheckGreenCircle,
  },
  props: {
    showLabel: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.exam-success {
  display: flex;
  padding: 24px;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;

  &__content {
    flex: 1;
    padding: 28px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__icon-wrapper {
    position: relative;
    display: inline-block;
  }

  &__circle {
    background-color: #c8eed3;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    svg path {
      fill: #2d954c;
    }
  }

  &__check {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__message {
    font-family: 'Dasa sans', sans-serif;
    font-weight: var(--font-weight-bold);
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #161616b8;
    margin-top: 16px;
  }
}
</style>
